import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["colorPrimary", "icon", "badge", "open", "defaultOpen", "placement", "trigger", "maxLastDay", "onOpenChange"];
import MsgList from "../MsgList";
import { MsgContext } from "../MsgProvider/msgContext";
import { queryReadUnreadCount } from "../services/api";
import { BellOutlined } from '@ant-design/icons';
import { Badge, ConfigProvider, Popover } from 'antd';
import classNames from 'classnames';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import React, { forwardRef, useContext, useEffect } from 'react';
import "./index.less";
var bellWrapDom = /*#__PURE__*/React.createElement("div", {
  className: "mcBellIcon"
}, /*#__PURE__*/React.createElement(BellOutlined, null));
var MsgPop = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$colorPrimary = props.colorPrimary,
    colorPrimary = _props$colorPrimary === void 0 ? '#1677ff' : _props$colorPrimary,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? bellWrapDom : _props$icon,
    _props$badge = props.badge,
    badge = _props$badge === void 0 ? {} : _props$badge,
    open = props.open,
    defaultOpen = props.defaultOpen,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottomRight' : _props$placement,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
    _props$maxLastDay = props.maxLastDay,
    maxLastDay = _props$maxLastDay === void 0 ? 30 : _props$maxLastDay,
    onOpenChange = props.onOpenChange,
    listProps = _objectWithoutProperties(props, _excluded);
  var _useContext = useContext(MsgContext),
    refresh = _useContext.refresh,
    triggerRefresh = _useContext.triggerRefresh,
    count = _useContext.count,
    _setCount = _useContext._setCount,
    token = _useContext.token,
    env = _useContext.env;

  //查询已读未读数量
  var handleQueryReadUnreadCount = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res, _res$object, read, unread;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _setCount({
              read: 0,
              unread: 0
            });
            _context.next = 3;
            return queryReadUnreadCount({
              max_days: maxLastDay
            }, {
              token: token,
              env: env
            });
          case 3:
            res = _context.sent;
            if (res && res.object) {
              _res$object = res.object, read = _res$object.read, unread = _res$object.unread;
              _setCount({
                read: read,
                unread: unread
              });
            } else {
              _setCount({
                read: 0,
                unread: 0
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleQueryReadUnreadCount() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    handleQueryReadUnreadCount();
  }, [refresh]);

  //innerOpen
  var _useMergedState = useMergedState(false, {
      value: open,
      defaultValue: defaultOpen
    }),
    _useMergedState2 = _slicedToArray(_useMergedState, 2),
    popOpen = _useMergedState2[0],
    sePopOpen = _useMergedState2[1];

  //弹窗显示隐藏的回调
  var onPopOpenChange = function onPopOpenChange(vis) {
    //打开时触发数据查询刷新
    if (vis) {
      if (triggerRefresh) {
        triggerRefresh();
      }
    }
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(vis);
    sePopOpen(vis);
  };
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    prefixCls: props.prefixCls || 'mc',
    theme: {
      token: {
        colorPrimary: colorPrimary
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(['mcNotify']),
    ref: ref
  }, /*#__PURE__*/React.createElement(Popover, {
    placement: placement,
    trigger: trigger,
    title: false,
    open: popOpen,
    onOpenChange: onPopOpenChange,
    content: /*#__PURE__*/React.createElement("div", {
      style: {
        width: '500px'
      }
    }, /*#__PURE__*/React.createElement(MsgList, _extends({}, listProps, {
      colorPrimary: colorPrimary,
      maxLastDay: maxLastDay
    }))),
    overlayInnerStyle: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Badge, _extends({
    count: count.unread
  }, badge), icon))));
});
export default MsgPop;